import React from "react";
import { Separator } from "_common/ui/components/Separator";
import { settingsStore } from "settings/_stores/settingsStore";
import { ISettingsMdl } from "settings/_models/SettingsMdl";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import canada from "../assets/images/flags/canPin.png";
import mexico from "../assets/images/flags/mexPin.png";

export function ContactUsAddresses() {
    const settings = settingsStore.getOne() as ISettingsMdl;
    const { t, i18n } = useTranslation();
    const lang = i18n.language;

    return (
        <div className={"mt-8"}>
            <Separator className={"mb-6"} />
            <div className={"mb-6 md:flex md:mb-8"}>
                <div className={"md:mr-8"}>
                    <iframe
                        src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2799.1331370670027!2d-73.43953678727891!3d45.44697317095307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc90ff15ba30caf%3A0x4e36bd6bcf2f7267!2s105%20Prom.%20des%20Lanternes%20%23250%2C%20Brossard%2C%20QC%20J4Y%200L2%2C%20Canada!5e0!3m2!1s${lang}!2sfr!4v1742463281408!5m2!1s${lang}!2sfr`}
                        width="254"
                        height="138"
                        allowFullScreen={false}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className={"rounded-lg"}
                    ></iframe>
                </div>
                <div className={"mt-4 md:flex md:items-center md:justify-center"}>
                    {settings?.contacts?.address && (
                        <div>
                            <div className={"flex flex-row gap-3 items-center md:gap-5"}>
                                <LazyLoadImage src={canada} className={"w-[30px] h-[34px] object-cover"} />
                                <a
                                    href={"https://maps.app.goo.gl/wC1zSsQSYicNV1sS8"}
                                    target={"_blank"}
                                    rel={"noreferrer noopener"}
                                    className={"text-black"}
                                >
                                    {t("contactPage.addressCa")}
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className={"md:flex"}>
                <div className={"md:mr-8"}>
                    <iframe
                        src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.4423472047583!2d-86.7468712!3d21.134787499999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4c2c09dc820c41%3A0x2f257685e799c209!2sCancun%20Center!5e0!3m2!1s${lang}!2sfr!4v1742463191385!5m2!1s${lang}!2sfr`}
                        width="254"
                        height="138"
                        allowFullScreen={false}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className={"rounded-lg"}
                    ></iframe>
                </div>
                <div className={"mt-4"}>
                    {settings?.contacts?.mexicanAddress && (
                        <div>
                            <div className={"flex flex-row gap-3 md:gap-5 items-center"}>
                                <LazyLoadImage src={mexico} className={"w-[30px] h-[34px] object-cover"} />
                                <a
                                    href={"https://maps.app.goo.gl/QQX5Y74dQcANb9rx6"}
                                    target={"_blank"}
                                    rel={"noreferrer noopener"}
                                    className={"text-black"}
                                >
                                    {t("contactPage.addressMex")}
                                </a>
                            </div>
                            <div hidden dangerouslySetInnerHTML={{ __html: settings.contacts.mexicanAddress }} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
